import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { createHorario } from '../../../controller/HorarioController';
import Horario from '../../../models/Horario' // Ajusta si la ruta es distinta

function HorarioCreateView() {
  const navigate = useNavigate();
  const [horario, setHorario] = useState(new Horario({}));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHorario({
      ...horario,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createHorario(horario);
      navigate(-1); // Vuelve a la vista anterior
    } catch (error) {
      console.error('Error al crear el horario:', error);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Crear Horario</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={horario.nombre}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Hora de Inicio</Form.Label>
          <Form.Control
            type="time"
            name="hora_inicio"
            value={horario.hora_inicio}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Hora de Fin</Form.Label>
          <Form.Control
            type="time"
            name="hora_fin"
            value={horario.hora_fin}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="me-2">
          Crear Horario
        </Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
      </Form>
    </Container>
  );
}

export default HorarioCreateView;
